import {
  createActivision,
  deleteAllActivisions,
  deleteRowService,
  getActivision,
  restoreAllActivisions,
  restoreRowService,
  softDeleteActivision,
  softDeleteAllActivisions,
  updateActivision,
} from "../../services/activisions";
import {
  activisionsLoading,
  activisionsError,
  setActivisionsList,
} from "../../slices/activisionsSlice";

export const getAction = () => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await getActivision();
    if (response?.error) {
      dispatch(activisionsError(response.error));
      return;
    } else {
      dispatch(setActivisionsList(response));
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const createAction = (formData) => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await createActivision(formData);
    if (response?.error) {
      dispatch(activisionsError(response.error));
      return;
    } else {
      dispatch(getAction());
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const updateAction = (formData) => async (dispatch) => {
  const table = formData.get("table");
  const id = formData.get("id");
  dispatch(activisionsLoading());
  try {
    const response = await updateActivision(formData);

    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        activisionsError(`Failed to update row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const softDeleteAction = (table, id, username) => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await softDeleteActivision(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        activisionsError(
          `Failed to softdelete row with ID ${id} in ${table} table`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const softDeleteAllAction = (table, username) => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await softDeleteAllActivisions(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(activisionsError(`Failed to delete records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const deleteRowAction = (table, id, username) => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await deleteRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        activisionsError(`Failed to delete row with ID ${id} in table ${table}`)
      );
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const deleteAllAction = (table, type, username) => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await deleteAllActivisions(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        activisionsError(
          `Failed to delete records in ${table} table of type ${type}`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const restoreRowAction = (table, id, username) => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await restoreRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        activisionsError(
          `Failed to recover row with ID ${id} in ${table} table`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};

export const restoreAllAction = (table, type, username) => async (dispatch) => {
  dispatch(activisionsLoading());
  try {
    const response = await restoreAllActivisions(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        activisionsError(
          `Failed to recover records in ${table} table of type ${type}`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(activisionsError(error.message));
    return;
  }
};
